/* eslint-disable no-return-await, no-template-curly-in-string */
import { fetchJson, fetchJsonWithRetries } from 'surface/api_fetch'
import { HTTPMethod } from '@padlet/fetch'
import template from 'lodash.template'
class FetchableObject {
  public static get url (): string {
    return ''
  }

  public static get fetchUrl (): string {
    return ''
  }

  public static buildUrl (url, options): string {
    return template(url)({ ...options, interpolate: /\${([\s\S]+?)}/g })
  }

  public static async readAll (options, fetchOptions = {}): Promise<any> {
    return await fetchJson(this.buildUrl(this.fetchUrl, options), {
      method: HTTPMethod.get,
      ...fetchOptions,
    })
  }

  public static async read (obj, fetchOptions = {}): Promise<any> {
    return await fetchJson(`${this.url}/${obj.id}`, {
      method: HTTPMethod.get,
      ...fetchOptions,
    })
  }

  public static async update (obj, fetchOptions = {}): Promise<any> {
    return await fetchJson(`${this.url}/${obj.id}`, {
      method: HTTPMethod.put,
      body: JSON.stringify(obj),
      ...fetchOptions,
    })
  }

  public static async create (obj, fetchOptions = {}): Promise<any> {
    return await fetchJson(`${this.url}`, {
      method: HTTPMethod.post,
      body: JSON.stringify(obj),
      ...fetchOptions,
    })
  }

  public static async delete (obj, fetchOptions = {}): Promise<any> {
    return await fetchJson(`${this.url}/${obj.id}`, {
      method: HTTPMethod.delete,
      ...fetchOptions,
    })
  }
}

class Reaction extends FetchableObject {
  public static get url (): string {
    return '/reactions'
  }

  public static get fetchUrl (): string {
    return '/reactions?wall_id=${ wall.id }'
  }
}

class PostConnection extends FetchableObject {
  public static get url (): string {
    return '/api/wish_connections'
  }

  public static get fetchUrl (): string {
    return '/api/wish_connections?wall_id=${ wall.id }'
  }
}

class Comment extends FetchableObject {
  public static get url (): string {
    return '/comments'
  }

  public static get fetchUrl (): string {
    return '/comments?wall_id=${ wall.id }'
  }
}

class WallSection extends FetchableObject {
  public static get url (): string {
    return '/wall_sections'
  }

  public static get fetchUrl (): string {
    return '/wall_sections?wall_id=${ wall.id }'
  }
}

class Wall extends FetchableObject {
  public static get url (): string {
    return '/walls'
  }

  private static get convertLayoutUrl (): string {
    return '/walls/${ id }/layout'
  }

  public static async convertLayout ({ id, newLayout }, fetchOptions = {}): Promise<any> {
    return await fetchJson(this.buildUrl(this.convertLayoutUrl, { id }), {
      method: HTTPMethod.put,
      body: JSON.stringify({ type: newLayout }),
      ...fetchOptions,
    })
  }
}

class Wish extends FetchableObject {
  public static get url (): string {
    return '/wishes'
  }

  public static get fetchUrl (): string {
    return '/wishes?wall_id=${ wall.id }'
  }

  public static get transferUrl (): string {
    return '/wishes/${ wish_id }/transfer'
  }

  public static get copyUrl (): string {
    return '/wishes/${ wish_id }/copy'
  }

  public static get approveUrl (): string {
    return '/wishes/${ wish_id }/approve'
  }

  public static async transfer ({
    wishId, wallId, wallSectionId, wallTitle, wallDescription,
  }, fetchOptions = {}): Promise<any> {
    return await fetchJson(this.buildUrl(this.transferUrl, { wish_id: wishId }), {
      method: HTTPMethod.put,
      body: JSON.stringify({
        wall_id: wallId,
        wall_section_id: wallSectionId,
        wall_title: wallTitle,
        wall_description: wallDescription,
      }),
      ...fetchOptions,
    })
  }

  public static async copy ({
    wishId, wallId, wallSectionId, wallTitle, wallDescription, postPosition,
  }, fetchOptions = {}): Promise<any> {
    return await fetchJson(this.buildUrl(this.copyUrl, { wish_id: wishId }), {
      method: HTTPMethod.post,
      body: JSON.stringify({
        wall_id: wallId,
        wall_section_id: wallSectionId,
        wall_title: wallTitle,
        wall_description: wallDescription,
        ...postPosition,
      }),
      ...fetchOptions,
    })
  }

  public static async approve ({ wishId }, fetchOptions = {}): Promise<any> {
    return await fetchJson(this.buildUrl(this.approveUrl, { wish_id: wishId }), {
      method: HTTPMethod.put,
      body: JSON.stringify({
      }),
      ...fetchOptions,
    })
  }

  public static async update (obj, fetchOptions = {}): Promise<any> {
    return await fetchJsonWithRetries(`${this.url}/${obj.id}`, {
      method: HTTPMethod.put,
      body: JSON.stringify(obj),
      ...fetchOptions,
    })
  }
}

export default {
  Reaction: Reaction,
  PostConnection: PostConnection,
  Comment: Comment,
  WallSection: WallSection,
  Wall: Wall,
  Wish: Wish,
}
